// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

/**
 * Success response schema
 */
export const successResponseSchema = z
  .object({
    data: z.object({ success: z.boolean() }),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    success: data.success,
  }));

export type SuccessResponse = z.infer<typeof successResponseSchema>;

/**
 * Reads a list the backend may send as null, or leave out altogether.
 *
 * Go serializes an uninitialised slice as `null` rather than `[]`, and drops the
 * key entirely when the field carries `omitempty`. All three mean the same thing
 * coming back, so every list schema coalesces rather than making each reader
 * check, and a field the backend can omit is read as nullish rather than failing
 * the whole response over an absent empty list.
 */
export function toArraySchema<Item extends z.ZodTypeAny>(item: Item) {
  return z
    .array(item)
    .nullish()
    .transform((values) => values ?? []);
}
